import { RouterLinkActive, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';

import * as RoutesDefinitions from '../../../routes-definitions';
import { NewFederationStep } from '../../enums';

@Component({
	selector: 'new-federation-steps',
	templateUrl: './new-federation-steps.component.html',
	imports: [RouterLinkActive, RouterLink, NgTemplateOutlet, TranslatePipe]
})
export class NewFederationStepsComponent {
	@Input() currentStep: NewFederationStep = NewFederationStep.Create;

	NewFederationStep = NewFederationStep;

	step1Link = RoutesDefinitions.getFederationCreateFullPath();
	step2Link = RoutesDefinitions.getFederationValidationFullPath();

	get showStep1Link() {
		return this.currentStep !== NewFederationStep.Validation;
	}

	get showStep2Link() {
		return this.currentStep === NewFederationStep.Validation;
	}
}
